import glam from 'glamorous';
import { BrandonGrotesque } from 'module/View/Common';

type WrapperProps = {
  descriptionWidth: number;
  inline: boolean;
};

export const Wrapper = glam.div<WrapperProps>(p => ({
  // display: 'flex',
  fontSize: '1rem',
  zIndex: 200,
  ...(p.inline
    ? {
        maxWidth: 350,
        position: 'relative',
      }
    : {
        position: 'fixed',
        height: 500,
        width: p.descriptionWidth,
        left: 0,
        top: 0,
      }),
  overflowY: 'auto',
  overflowX: 'hidden',
  transition: 'height .3s',
}));

type DescWrapperProps = {
  width: number;
  inline: boolean;
};

export const DescWrapper = glam.div<DescWrapperProps>(props => ({
  ...(props.inline ? { paddingBottom: '1rem' } : { padding: '1rem', width: props.width, flexShrink: 0 }),
  fontSize: '1em',
  background: 'rgba(255, 255, 255, 0.92)',
}));

export const Title = glam.h1({
  fontSize: '2.6em',
  fontFamily: BrandonGrotesque.medium,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 1.2,
  margin: 0,
});



// WEBPACK FOOTER //
// ./src/module/View/Publication/PublicationDescription/PublicationDescription.s.ts